import React from 'react';
import {useIntl} from 'react-intl';
import './notification.sass';
import DataTable from '../../components/dataTable';
import useStore from '../../hooks/use-store';
import {canSeeAuditFields} from '../../helpers/auth';


const NotificationTable = (props) => {
  const intl = useIntl();
  const {store} = useStore();
  const showAuditFields = canSeeAuditFields(store.auth.profile);
  const {
    notificationForm,
    removeRegister,
    attributes,
    list,
    loading,
  } = props;

  return (
    <DataTable
      add={notificationForm}
      edit={notificationForm}
      remove={removeRegister}
      list={list}
      loading={loading}
      attributes={attributes}
      keyField={'id'}
      confirmText={intl.formatMessage({id: 'notificationRemoveConfirm'})}
      headers={[
        {title: 'notificationType', field: 'title', dataSort: true},
        {title: 'notificationAlways', field: 'always', dataSort: true},
        // Essa coluna guarda a lista bruta de alarmes (attributes.alarms), pode
        // ter muito mais texto que qualquer título -- nunca expande além de título×1.5, corta com
        // reticência (já vem da lib) em vez de esticar a tabela inteira.
        {title: 'sharedAlarms', field: 'alarms', dataSort: false, maxWidthRatio: 1.5},
        {title: 'notificationNotificators', field: 'notificators', dataSort: false},
        ...(showAuditFields ? [
          {title: 'sharedCreatedBy', field: 'creatorName', dataSort: true},
          {title: 'sharedCreatorEmail', field: 'creatorEmail', dataSort: true},
          {title: 'sharedCreatedAt', field: 'createdAtFormatted', dataSort: true},
          {title: 'sharedUpdatedAt', field: 'updatedAtFormatted', dataSort: true},
        ] : []),
      ]}
    />
  );
};

export default NotificationTable;
